import { getRequest, postRequest } from '../baseRequest'
import { filterEmptyParams } from '@/utils/formatObject'

// 创建表单
export const createFormRequest = (data) => postRequest('/user/form/create', data)
// 创建表单
export const copyFormRequest = (data) => postRequest('/user/form/copy', data)
// 修改表单
export const updateFormRequest = (data) => postRequest('/user/form/update', data)
export const updateProjectRequest = (data) => postRequest(`/user/form/updateFormShopRelation`, data)

// 获取项目详情
export const getProjectDetailRequest = (formKey) => getRequest(`/user/form/getFormRelationships/${formKey}`)
export const getProjectRequest = (formKey) => getRequest(`/user/form/${formKey}`)

//恢复表单
export const restoreRecycleFormRequest = (data) => postRequest('/user/form/recycle/restore', data)
// 从回收站删除表单
export const deleteRecycleFormRequest = (data) => postRequest('/user/form/recycle/delete', data)
// 查询回收站表单
export const listRecycleFormRequest = (data) => getRequest('/user/form/recycle/page', data)
// 逻辑删除表单
export const logicDeleteFormRequest = (data) => postRequest('/user/form/logic/delete', data)
// 删除表单
export const deleteFormRequest = (data) => postRequest('/user/form/delete', data)

// 停止收集表单
export const stopFormRequest = (data) => postRequest('/user/form/stop', data)

// 查询表单分页
export const pageFormRequest = (data) => postRequest('/user/form/page', data)

// 查询表单项内容
export const listProjectItemRequest = (params) => getRequest('/user/form/item/list', params)

// 查询数据页表单表头
export const listFormFieldsRequest = (formKey) => getRequest(`/user/form/fields/${formKey}`)

// 查询固定表单项内容
export const listFixedFormFieldsRequest = (formKey) => getRequest(`/user/form/fixed/fields/${formKey}`)

// 查询表单逻辑列表
export const getFormLogicRequest = (params) => getRequest('/user/form/logic', params)

// 保存表单逻辑
export const saveFormLogicRequest = (data) => postRequest('/user/form/logic/save', data)

// 查询主题列表
export const listThemeRequest = (params) => getRequest('/form/theme/list', params)

// 保存表单选中主题
export const saveUserThemeRequest = (data) => postRequest('/user/form/theme/save', data)

// 保存自定义外观
export const saveDefineThemeRequest = (data) => postRequest('/user/form/define/theme/save', data)

// 查询表单主题
export const getUserThemeRequest = (projectKey) => getRequest(`/user/form/theme/${projectKey}`)

// 查询自定义外观
export const getDefineThemeRequest = (projectKey) => getRequest(`/user/form/details/${projectKey}`)

// ------------------
// 获取项目详情
export const queryProject = (formKey) => getRequest(`/user/form/${formKey}`)

// 更新项目
export const updateProject = (data) => postRequest('/user/form/update', data)

// 创建项目表单项
export const createProjectItem = (data) => postRequest('/user/form/item/create', data)

// 创建项目表单项
export const batchCreateProjectItem = (data) => postRequest('/user/form/item/batch/create', data)

// 更新项目表单项
export const updateProjectItem = (data) => postRequest('/user/form/item/update', data)

// 查询单选/多选选项扩展信息
export const getFormItemOptionsExtension = (formItemId) =>
  getRequest(`/user/form/queryFormItemOptionsExtensionByFormItemId/${formItemId}`)

// 查询单选/多选选项扩展信息
export const getAllFormItemOptionsExtension = (formKey) =>
  getRequest(`/user/form/queryFormItemOptionsExtensionByFormKey/${formKey}`)

// 更新单选/多选选项扩展信息
export const updateFormItemOptions = (data) => postRequest('/user/form/updateFormItemOptionsExtension', data)

// 手动更新问卷
export const publishProject = (data) => postRequest('/user/form/publish', data)

// 删除项目表单项
export const deleteProjectItem = (data) => postRequest('/user/form/item/delete', data)

// 查询项目表单项
export const queryProjectItemList = (formKey) => getRequest('/user/form/item/list', formKey)

// 排序项目表单项
export const sortProjectItem = (data) => postRequest('/user/form/item/sort', data)

// 表单逻辑项
export const queryFormLogic = (params) => getRequest('/user/form/logic', params)

// 停止发布表单
export const stopPublishFormRequest = (data) => postRequest('/user/form/stop', data)

// 查询部门员工列表
export const getEmpTreeRequest = (params) => getRequest('/organization/empTrees', params)

// 查询部门列表
export const getDeptTreeRequest = (params) => getRequest('/organization/deptTrees', params)

// 查询账号拥有的品牌
export const getUserBrandList = () => getRequest('/brand/getUserBrandList')

// 品牌门店信息
export const getShopByBrand = (data) => postRequest(`/shop/queryShopByBrand`, data)
// 获取表单大纲
export const getOutlineList = (data) => postRequest('/user/form/item/outline', filterEmptyParams(data))

// 移动
export const saveOutlineMove = (data) => postRequest('/user/form/item/outline/move', filterEmptyParams(data))
// 表单大纲复制表单项
export const copyOutlineProject = (data) => postRequest('/user/form/item/outline/copy', filterEmptyParams(data))
// 表单大纲批量删除表单项
export const batchDeleteOutlineProject = (data) => postRequest('/user/form/item/batchDelete', data)
// 在对应题目组位置后新增题目组
export const createGroup = (formKey, index) => getRequest(`/user/form/item/group/create/${formKey}/${index}`)
// 删除题目组
export const deleteGroup = (params) =>
  getRequest(`/user/form/item/group/delete/${params.formKey}/${params.formItemGroupId}`)
// 查询题目组下题目
export const getGroupFromItem = (params) => getRequest('/user/form/item/group/query', params)
// 移动题目组
export const groupMove = (data) => postRequest('/user/form/item/group/move', data)
// 复制题目组
export const copyGroup = (params) =>
  getRequest(`/user/form/item/group/copy/${params.formKey}/${params.formItemGroupId}`)

// 编辑题目组
export const editGroup = (data) => postRequest('/user/form/item/group/edit', data)

// 获取题目组下的题目
export const getQuestionFromGroup = (params) =>
  getRequest(`/user/form/item/group/query/${params.formKey}/${params.formItemGroupId}`)
// 修改题目组随机抽取逻辑
export const updateRandomLogic = (formKey, formItemGroupId, data) =>
  postRequest(`/user/form/item/group/update/randomLogic/${formKey}/${formItemGroupId}`, data)

// 问卷表单撤销操作(5分钟内)
export const undoFormApi = (formKey) => getRequest(`/user/form/item/undo/${formKey}`)

// 获取表单协助者
export const getFormAssistant = (formKey) => getRequest(`/user/form/assistant/${formKey}`)

// 获取表单协助者
export const editFormAssistant = (formKey, data) => postRequest(`/user/form/assistant/edit/${formKey}`, data)

// 获取表单权限配置
export const getFormPermission = (formKey) => getRequest(`/user/form/permission/${formKey}`)

// 保存表单权限配置
export const saveFormPermission = (formKey, data) => postRequest(`/user/form/permission/${formKey}`, data)

// 查询表单协作者列表
export const getFormAssistantList = (data) => getRequest(`/mange/user/simpleUserQuery`, data)

//

export default {
  queryProject,
  updateProject,
  createProjectItem,
  updateProjectItem,
  deleteProjectItem,
  sortProjectItem
}
